import { Outlet, Navigate, NavLink } from "react-router-dom";
import { EndUserAuthProvider, useEndUser } from "@/lib/endUserAuth";
import { Activity, Home, History, User } from "lucide-react";

// Spinner a pantalla completa (reusa los tokens de la paleta).
function FullScreenSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-8 h-8 border-3 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

// Provee el contexto de identidad del usuario final a TODO /app/*.
// Se monta como layout route para que login/claim también puedan usar useEndUser.
export function AppProviderLayout() {
  return (
    <EndUserAuthProvider>
      <Outlet />
    </EndUserAuthProvider>
  );
}

const NAV = [
  { to: "/app", label: "Hoy", icon: Home, end: true },
  { to: "/app/historial", label: "Historial", icon: History, end: false },
  { to: "/app/perfil", label: "Perfil", icon: User, end: false },
];

// Layout protegido: exige sesión de EndUser. Renderiza el chrome de la app
// (header + bottom nav) alrededor del Outlet. Mobile-first (max-w-md centrado).
export function AppProtectedLayout() {
  const { endUser, loading } = useEndUser();
  if (loading) return <FullScreenSpinner />;
  if (!endUser) return <Navigate to="/app/login" replace />;

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="bg-primary text-primary-foreground sticky top-0 z-20">
        <div className="max-w-md mx-auto px-4 h-14 flex items-center gap-2">
          <Activity className="w-5 h-5" />
          <span className="text-sm font-semibold">Fisiotherapy</span>
        </div>
      </header>

      {/* Contenido (con padding inferior para no quedar bajo el bottom nav) */}
      <main className="flex-1 w-full max-w-md mx-auto px-4 pt-4 pb-24">
        <Outlet />
      </main>

      {/* Bottom nav fijo */}
      <nav className="fixed bottom-0 inset-x-0 z-20 border-t border-border bg-card">
        <div className="max-w-md mx-auto grid grid-cols-3">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] font-medium transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`
              }
            >
              <Icon className="w-5 h-5" />
              {label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
